import 'jquery-match-height';

jQuery(document).ready(function ($) {
    $('.match').matchHeight();
});
